<template>
  <pvd-loading-spinner
    active="true"
    type="brand"
    :message="pageTitle"
    class="mt-4"
  />
</template>
<script>

import dataHelper from '../mixins/dataHelper';

export default {
  name: 'TrustSigning',
  mixins: [
    dataHelper,
  ],
  data() {
    return {
      pageTitle: 'Preparing signing ceremony',
    };
  },
  created() {
    document.location.href = this.getInstanceData().currentState.envelope.url;
  },
  mounted() {
    document.title = this.setTitle(this.pageTitle);
  },
};

</script>

<style scoped>
  .mt-4{
    margin-top: 4rem;
  }
</style>
